import { type ReloadOptions, WhenVisible } from "@inertiaui/modal-react";
import type ProfileFriendshipsShow from "@travily/types/pages/ProfileFriendshipsShow";
import type { ReactNode } from "react";
import { RoutedModal } from "@/components/RoutedModal";
import { useFriendshipsModal } from "@/hooks/use-friendships-modal";
import { FriendshipsModal } from "./show.view";

interface FriendshipsContentProps {
  close: () => void;
  friends: ProfileFriendshipsShow["friends"];
  friendsPagy: ProfileFriendshipsShow["friends_pagy"];
  isOwnProfile: boolean;
  reload: (options?: ReloadOptions) => void;
}

function FriendshipsContent({ close, friends, friendsPagy, isOwnProfile, reload }: FriendshipsContentProps) {
  const { hasMore, loadMoreParams, ...modal } = useFriendshipsModal({ friends, friendsPagy, reload });

  return (
    <FriendshipsModal
      {...modal}
      isOwnProfile={isOwnProfile}
      onClose={close}
      // @inertiaui's modal-aware WhenVisible: scrolls into view -> partial reload of
      // the next page. Lives here (not in product-ui) so Inertia deps stay app-side.
      // The 1px child is the observed sentinel; the loading spinner is the modal's.
      paginationSlot={
        hasMore ? (
          <WhenVisible always buffer={150} fallback={null} params={loadMoreParams}>
            <div aria-hidden className="h-px w-full" />
          </WhenVisible>
        ) : null
      }
    />
  );
}

const FriendshipsShowPage = ({ is_own_profile, friends, friends_pagy }: ProfileFriendshipsShow) => (
  <RoutedModal size="lg">
    {({ close, reload }) => (
      <FriendshipsContent
        close={close}
        friends={friends}
        friendsPagy={friends_pagy}
        isOwnProfile={is_own_profile}
        reload={reload}
      />
    )}
  </RoutedModal>
);

FriendshipsShowPage.layout = (page: ReactNode) => page;

export default FriendshipsShowPage;
